// import { useState } from 'react'; 구글 폼 사용할 경우
import Banner from '../../Components/Layout/Banner/Banner.js';
import Portrait1 from '../../Assets/Img/BaeWonsikPortrait.webp'
// import ProfileImg2 from '../../assets/Img/Profile2.png';
import '../Contact/Contact.css';

function Contact() {
    // const [showForm, setShowForm] = useState(false); 구글 폼 사용 할 경우
    // 변호사 데이터를 배열로 관리 (추가될 때마다 이 배열에 객체만 추가하면 됨)
    // 변호사 데이터 관리 (내용 유지)
    const lawyers = [
        {
            id: 1,
            name: "배원식",
            role: "대표변호사",
            img: Portrait1,
            summary: [
                "• 대한변호사협회 등록 형사전문변호사",
                "• 민사, 가사, 가상자산 등 다수의 승소 경험",
                "• 의뢰인과 직접 소통하는 냉철한 해결사"
            ],
            link: "https://lfind.kr/lawyers/%EB%B0%B0%EC%9B%90%EC%8B%9D-82237"
        }
        // 두 번째 변호사 추가 예시
        // {
        //     id: 2,
        //     name: "배원식",
        //     role: "대표변호사",
        //     img: ProfileImg1,
        //     summary: [
        //         "• 대한변호사협회 등록 형사전문변호사",
        //         "• 민사, 가사, 가상자산 등 다수의 승소 경험",
        //         "• 의뢰인과 직접 소통하는 냉철한 해결사"
        //     ],
        //     link: "https://lfind.kr/lawyers/%EB%B0%B0%EC%9B%90%EC%8B%9D-82237"
        // },
        // {
        //     id: 3,
        //     name: "배원식",
        //     role: "대표변호사",
        //     img: ProfileImg1,
        //     summary: [
        //         "• 대한변호사협회 등록 형사전문변호사",
        //         "• 민사, 가사, 가상자산 등 다수의 승소 경험",
        //         "• 의뢰인과 직접 소통하는 냉철한 해결사"
        //     ],
        //     link: "https://lfind.kr/lawyers/%EB%B0%B0%EC%9B%90%EC%8B%9D-82237"
        // },
        // {
        //     id: 4,
        //     name: "배원식",
        //     role: "대표변호사",
        //     img: ProfileImg1,
        //     summary: [
        //         "• 대한변호사협회 등록 형사전문변호사",
        //         "• 민사, 가사, 가상자산 등 다수의 승소 경험",
        //         "• 의뢰인과 직접 소통하는 냉철한 해결사"
        //     ],
        //     link: "https://lfind.kr/lawyers/%EB%B0%B0%EC%9B%90%EC%8B%9D-82237"
        // }
    ];

    return (
        <>
            <Banner />
            <div className="contact-page-wrapper">
                <div className="container py-5">
                    {/* PC에서 2열(lg-2), 모바일에서 1열로 배치되는 그리드 */}
                    <div className="row row-cols-1 row-cols-lg-2 g-4 justify-content-center">
                        {lawyers.map((lawyer) => (
                            <div className="col" key={lawyer.id}>
                                <div className="contact-card bg-white overflow-hidden h-100">
                                    <div className="row g-0 align-items-center h-100">
                                        {/* 왼쪽: 이미지 영역 */}
                                        <div className="col-5 col-md-5 profile-img-container">
                                            <img
                                                src={lawyer.img}
                                                alt={`${lawyer.name} 변호사`}
                                                className="profile-img"
                                            />
                                        </div>

                                        {/* 오른쪽: 프로필 및 버튼 영역 */}
                                        <div className="col-7 col-md-7 p-4">
                                            <p className="small fw-bold mb-2" style={{ color: '#ff5a30' }}>PREMIUM COUNSEL</p>
                                            <h5 className="mb-1 text-muted small">법률사무소 온평</h5>
                                            <h2 className="fw-bold mb-4" style={{ fontSize: '1.5rem' }}>
                                                {lawyer.name} <span className="fs-6 text-secondary">{lawyer.role}</span>
                                            </h2>

                                            <ul className="list-unstyled mb-4 profile-summary d-inline-block d-md-block">
                                                {lawyer.summary.map((item, index) => (
                                                    <li key={index}>{item}</li>
                                                ))}
                                            </ul>

                                            <div className="cta-wrapper">
                                                <a
                                                    href={lawyer.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-lg lfind-btn px-4 w-100"
                                                >
                                                    엘파인드 상담 예약
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* [하단] 간편 상담 섹션 (주석 유지) */}
                    {/* <div className="contact-section-item mt-5 mx-auto">
                        <div className="contact-card simple-contact-card shadow-sm border rounded p-4 bg-white text-center">
                            <p className="small fw-bold mb-2" style={{ color: '#c5a059' }}>간편 신청</p>
                            <h3 className="fw-bold mb-1">무료 간편 상담 신청</h3>
                            <p className="text-muted small mb-4">내용을 남겨주시면 담당자가 연락드립니다.</p>
                            {!showForm ? (
                                <button className="btn btn-lg btn-gold" onClick={() => setShowForm(true)}>
                                    준비 중 입니다 (신청 불가능)
                                </button>
                            ) : (
                                <button className="btn btn-lg btn-outline-secondary" onClick={() => setShowForm(false)}>
                                    작성 창 닫기
                                </button>
                            )}
                        </div>
                        {showForm && (
                            <div className="form-container mt-4 shadow-sm rounded overflow-hidden border bg-white animate-fade-in">
                                <iframe src="..." width="100%" height="1000" title="상담 신청 폼" style={{ border: 'none' }}>로드 중…</iframe>
                            </div>
                        )}
                    </div> 
                    */}
                </div>
            </div>
        </>
    );
}

export default Contact;